import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { ImageGroupDto, InfoForHomeDto } from '../../dto-common-website/images/models';
import type { ImageGroupName } from '../../utils/image-group-name.enum';

@Injectable({
  providedIn: 'root',
})
export class ImageService {
  apiName = 'Default';
  

  getImageGroupFromName = (imageGroupEnum: ImageGroupName, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ImageGroupDto>({
      method: 'GET',
      url: '/api/app/image/image-group-from-name',
      params: { imageGroupEnum },
    },
    { apiName: this.apiName,...config });
  

  getInfoForHome = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, InfoForHomeDto>({
      method: 'GET',
      url: '/api/app/image/info-for-home',
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
